import React, { useState } from "react";
import { Button, Container, Form, Row, Col, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DefaultLayout from "../../components/layout/DefaultLayout";
import freeResourceApi from "../../apis/freeResourceApi";
import { fetchResourcesAction } from "./freeResourceAction";

const categories = ["Book", "Video", "Article", "Course", "Cheat Sheet"];

const AddFreeResource = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    description: "",
    destinationUrl: "",
    addedBy: "",
    thumbnail: "",
    buttonText: "View Details",
    status: "active",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting form:", form);
    setIsLoading(true);

    try {
      const res = await freeResourceApi.createAResource(form);
      console.log("API Response:", res);
      setIsLoading(false);

      if (res?._id || res?.status === "success") {
        toast.success(res.message || "Resource created successfully!");
        dispatch(fetchResourcesAction());
        navigate("/free-resources");
      } else {
        toast.error(res?.message || "Failed to create resource. Please try again.");
      }
    } catch (error) {
      console.error("Error creating resource:", error);
      setIsLoading(false);
      toast.error("An error occurred. Please check your connection and try again.");
    }
  };

  return (
    <DefaultLayout>
      <Container>
        <Row className="mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1>Add New Resource</h1>
            <Button variant="secondary" onClick={() => navigate("/free-resources")}>
              &lt; Back
            </Button>
          </div>
        </Row>
        <hr />
        <Row className="mt-3">
          <Col md={8} className="m-auto">
            <Form onSubmit={handleOnSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  name="name"
                  value={form.name}
                  placeholder="Resource Name"
                  required
                  onChange={handleOnChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Description *</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  value={form.description}
                  placeholder="Resource Description"
                  rows={3}
                  required
                  onChange={handleOnChange}
                />
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Added By *</Form.Label>
                    <Form.Control
                      name="addedBy"
                      value={form.addedBy}
                      placeholder="Added By"
                      required
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Status *</Form.Label>
                    <Form.Select
                      name="status"
                      value={form.status}
                      required
                      onChange={handleOnChange}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Destination URL *</Form.Label>
                    <Form.Control
                      name="destinationUrl"
                      value={form.destinationUrl}
                      placeholder="https://example.com"
                      required
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Button Text *</Form.Label>
                    <Form.Control
                      name="buttonText"
                      value={form.buttonText}
                      placeholder="e.g. View Details"
                      required
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Thumbnail URL *</Form.Label>
                <Form.Control
                  name="thumbnail"
                  value={form.thumbnail}
                  placeholder="https://example.com/image.png"
                  required
                  onChange={handleOnChange}
                />
              </Form.Group>

              <div className="d-grid mt-4">
                <Button variant="warning" type="submit" disabled={isLoading}>
                  {isLoading ? <Spinner animation="border" size="sm" /> : "Create Resource"}
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </DefaultLayout>
  );
};

export default AddFreeResource;
